export default "__VITE_ASSET__bad10316__"